// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SubmitApprovalRequest
 */
export interface SubmitApprovalRequest {
    /**
     * 
     * @type {string}
     * @memberof SubmitApprovalRequest
     */
    approval_comment?: string;
    /**
     * 
     * @type {string}
     * @memberof SubmitApprovalRequest
     */
    stage: string;
}

/**
 * Check if a given object implements the SubmitApprovalRequest interface.
 */
export function instanceOfSubmitApprovalRequest(value: object): value is SubmitApprovalRequest {
    if (!('stage' in value) || value['stage'] === undefined) return false;
    return true;
}

export function SubmitApprovalRequestFromJSON(json: any): SubmitApprovalRequest {
    return SubmitApprovalRequestFromJSONTyped(json, false);
}

export function SubmitApprovalRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubmitApprovalRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'approval_comment': json['approval_comment'] == null ? undefined : json['approval_comment'],
        'stage': json['stage'],
    };
}

export function SubmitApprovalRequestToJSON(json: any): SubmitApprovalRequest {
    return SubmitApprovalRequestToJSONTyped(json, false);
}

export function SubmitApprovalRequestToJSONTyped(value?: SubmitApprovalRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'approval_comment': value['approval_comment'],
        'stage': value['stage'],
    };
}
